<template>
  <div class="level4-search-component">
    <Level4Forms/>
    <Level4CategoryMenu />
  </div>
</template>

<script>
import Level4Forms from './search/Level4Forms.vue';
import Level4CategoryMenu from './category/Level4CategoryMenu.vue';

export default {
  name: 'Level4Search',
  components: {
    Level4Forms,
    Level4CategoryMenu,
  },
};
</script>
